import getFlaggedConnectionStore from "../../../../stores/developer-store/flagged-connections-store";
import Et3Button from "../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";

const FlaggedConnectionsDashboardForm = withLiteObserverAndTheme(() => {
  return (
    <Et3Button
      isEnabled={true}
      onClick={async () => {
        getFlaggedConnectionStore().getFlaggedConnections();
      }}
      size="LARGE"
      text="GET"
      type="GET"
    />
  );
});

export default FlaggedConnectionsDashboardForm;
